module.exports = __webpack_public_path__ + "static/media/partner-logo-kw.8dbac34c.png";